import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    api_token: localStorage.getItem('api-token') || '',
    authenticated: false,
    user: null,
    api_key: localStorage.getItem('api-key') || null,
    store: null,
    posSettings: null
  },
  getters: {
    isAuthenticated: state => !!state.api_token,
    hasApiKey: state => !!state.api_key
  },
  mutations: {
    authenticationSuccess: (state, user) => {
      state.api_token = user.api_token
      state.user = user
      state.authenticated = true
    },
    setUser: (state, user) => {
      state.user = user
      state.authenticated = true
    },
    setApiKey: (state, apiKey) => {
      state.api_key = apiKey
    },
    setStore: (state, store) => {
      state.store = store
    },
    setPosSettings: (state, posSettings) => {
      state.posSettings = posSettings
    },
    processLogout: (state) => {
      state.api_token = null
      state.authenticated = false
      state.user = null
      state.api_key = null
      state.store = null
    }
  },
  actions: {
    processLogin: ({commit, dispatch}, user) => {
      return new Promise((resolve, reject) => { // The Promise used for router redirect in login
        axios({url: process.env.URLS_POS_API + '/auth/login', data: user, method: 'POST'})
          .then(resp => {
            const user = resp.data.data
            localStorage.setItem('api-token', user.api_token) // store the token in localstorage
            commit('authenticationSuccess', user)
            // you have your token, now log in your user :)
            resolve(resp)
          })
          .catch(err => {
            localStorage.removeItem('api-token') // if the request fails, remove any possible user token if possible
            reject(err)
          })
      })
    },
    authenticationSuccess: ({commit, dispatch}, user) => {
      localStorage.setItem('api-token', user.api_token) // store the token in localstorage
      commit('authenticationSuccess', user)
    },
    getUser: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => { // The Promise used for router redirect in login
        axios({url: process.env.URLS_POS_API + '/user', method: 'GET'})
          .then(resp => {
            commit('setUser', resp.data.data)
            // you have your token, now log in your user :)
            resolve(resp)
          })
          .catch(err => {
            localStorage.removeItem('api-token') // if the request fails, remove any possible user token if possible
            document.location.href = '/'
            reject(err)
          })
      })
    },
    processLogout: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
        commit('processLogout')
        localStorage.removeItem('api-token')
        localStorage.removeItem('api-key')
        resolve()
      })
    },
    getStore: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios({url: process.env.URLS_POS_API + '/store', method: 'GET'})
          .then(resp => {
            commit('setStore', resp.data.data)
            resolve(resp)
          })
          .catch(err => {
            localStorage.removeItem('api-key')
            commit('setApiKey', null)
            reject(err)
          })
      })
    },
    setStore: ({ commit }, store) => {
      commit('setStore', store)
    },
    generateOrSetApiKey: ({ state, commit }) => {
      return new Promise((resolve, reject) => {
        axios({url: process.env.URLS_POS_API + '/stores/' + state.store.id + '/api_key', method: 'GET'})
          .then(resp => {
            localStorage.setItem('api-key', resp.data.data.api_key)
            commit('setApiKey', resp.data.data.api_key)
            axios.defaults.headers.common['X-API-KEY'] = resp.data.data.api_key
            resolve(resp)
          })
          .catch(err => {
            localStorage.removeItem('api-key')
            reject(err)
          })
      })
    },
    getPosSettings: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios({url: process.env.URLS_POS_API + '/settings', method: 'GET'})
          .then(resp => {
            commit('setPosSettings', resp.data.data)
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    setPosSettings: ({ commit }, posSettings) => {
      commit('setPosSettings', posSettings)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js